import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

export default function AzureSPConnectTestingPhase({
  shown,
}: Props): JSX.Element | null {
  if (!shown) {
    return null;
  }

  //
  return (
    <ServiceConnectionStep disabled={false}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <CircularProgress sx={{ mr: 1 }} size="16px" /> Testing connection...
      </Box>
    </ServiceConnectionStep>
  );
}

// -----------------------------------------------------------------------------

interface Props {
  shown: boolean;
}
